import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import api from '../../../../services/api';

const formatCurrencyBR = (value) => {
    const number = Number(value);
    if (Number.isNaN(number)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
};

const FinancialAgingReport = () => {
    const [appId, setAppId] = useState(null);
    const [type, setType] = useState('receivable');
    const [data, setData] = useState(null);

    useEffect(() => {
        (async () => {
            const res = await api.get('v1/apps/default/');
            setAppId(res.data.app.id);
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        (async () => {
            const res = await api.get(`v1/apps/${appId}/reports/financial/aging/?type=${type}`);
            setData(res.data);
        })();
    }, [appId, type]);

    if (!data) return null;

    const columnLabel = type === 'payable' ? 'Fornecedor' : 'Cliente';

    return (
        <Box p={{ xs: 2, md: 4 }}>
            <Typography variant="h4" fontWeight="700" mb={1}>
                Contas em Aberto (Aging)
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={4}>
                Agrupado por organização e faixa de atraso
            </Typography>

            <TextField select label="Tipo" size="small" sx={{ width: 200, mb: 3 }} value={type} onChange={(e) => setType(e.target.value)}>
                <MenuItem value="receivable">Contas a receber</MenuItem>
                <MenuItem value="payable">Contas a pagar</MenuItem>
            </TextField>

            <Card>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>{columnLabel}</TableCell>
                                <TableCell align="right">Em dia</TableCell>
                                <TableCell align="right">1-30 dias</TableCell>
                                <TableCell align="right">31-60 dias</TableCell>
                                <TableCell align="right">61-90 dias</TableCell>
                                <TableCell align="right">+90 dias</TableCell>
                                <TableCell align="right">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.rows.map((row) => (
                                <TableRow key={row.organization}>
                                    <TableCell>{row.organization_name}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.current)}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.d1_30)}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.d31_60)}</TableCell>
                                    <TableCell align="right">{formatCurrencyBR(row.d61_90)}</TableCell>
                                    <TableCell align="right" sx={{ color: Number(row.d90_plus) > 0 ? 'error.main' : 'inherit' }}>
                                        {formatCurrencyBR(row.d90_plus)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(row.total)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {data.rows.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        Nenhuma conta em aberto
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {data.rows.length > 0 && (
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Total</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(data.totals.current)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(data.totals.d1_30)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(data.totals.d31_60)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(data.totals.d61_90)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(data.totals.d90_plus)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        {formatCurrencyBR(data.totals.total)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </CardContent>
            </Card>
        </Box>
    );
};

export default FinancialAgingReport;
